import React from 'react';
import './sectionHeader.scss'

export const SectionHeader = ({ sectionTitle, styles, cssClasses }) => {
  return (
    <h5
      className={`section-heading ${cssClasses}`}
      style={{ color: styles.color, fontWeight: 500 }}
    >
      {sectionTitle}
    </h5>
  )
}